import styled from 'styled-components'

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ gap }) => gap || '12px'};
	width: ${({ width }) => width || '100%'};
	margin-bottom: ${({ mb }) => mb || '48px'};
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		margin-bottom: ${({ mb }) => mb || '32px'};
	}
`

export const SectionHeader = styled.div`
	display: flex;
	justify-content: ${({ justify }) => justify || 'space-between'};
	align-items: ${({ align }) => align || 'center'};
	flex-direction: ${({ direction }) => direction || 'column'};
	gap: ${({ gap }) => gap || '12px'};
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		display: flex;
		flex-direction: ${({ directionMonbile }) => directionMonbile || 'column'};
		align-items: ${({ alignMobile }) => alignMobile || 'flex-start'};
		gap: ${({ gap }) => gap || '8px'};
	}
`

export const SectionTitle = styled.h2`
	font-size: 24px;
	font-weight: 600;
	color: #1a1a1a;
	margin: 0 0 ${({ mbDesktop }) => mbDesktop || '24px'} 0;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		font-size: 20px;
		margin-bottom: ${({ mb }) => mb || '16px'};
	}
`
